import { observer } from 'mobx-react-lite'
import { OCRConfirmBulkReviewDialog } from '@/features/jobs/scoping/components/OCRConfirmBulkReviewDialog'
import { type OCRConfirmBulkReviewDialogViewModel } from './OCRConfirmBulkReviewDialogViewModel'

export interface OCRConfirmBulkReviewDialogContainerProps {
  vm: OCRConfirmBulkReviewDialogViewModel
}

export const OCRConfirmBulkReviewDialogContainer = observer(
  function OCRConfirmBulkReviewDialogContainer({
    vm,
  }: OCRConfirmBulkReviewDialogContainerProps) {
    return (
      <OCRConfirmBulkReviewDialog
        showing={vm.modal.showing}
        selectedCount={vm.selectedCount}
        onClose={vm.cancel}
        onConfirm={vm.confirm}
      />
    )
  },
)
